import React from 'react'
import styled from 'styled-components'
import ReactHtmlParser from 'react-html-parser'
import getSecretColor from '@libs/getSecretColor'

const Container = styled.div`
  min-height: 450px;
  padding: 40px 20px;

  h1 {
    font-size: 1.7rem;
    line-height: 1.5em;
    margin-bottom: 5px;
  }

  p {
    color: #58595b;
    font-size: 1.3rem;
    line-height: 1.8em;
    min-height: 1em;
    margin: 0 auto;
    text-align: center;
  }
`

type Props = {
  secretColor: string
  title: string
  content: string
}

function ContentBlock(props: Props) {
  const { secretColor = getSecretColor(), title, content } = props

  return (
    <Container style={{ backgroundColor: secretColor }}>
      {title && <h1>{title}</h1>}
      {content && <p>{ReactHtmlParser(content)}</p>}
    </Container>
  )
}

export default ContentBlock
